<script>
	import { onMount } from 'svelte';

	let services = ['server', 'interface', 'design'];

	onMount(switchService);

	function switchService() {
		setInterval(() => {
			const updatedServices = [...services];
			updatedServices.push(updatedServices.shift());
			services = updatedServices;
		}, 2000);
	}
</script>

<section class="hero">
	<div class="title">Web Frontier</div>
	<div class="what-we-are">digital realization of your idea</div>
	<div class="produce">we are produce:</div>
	<div class="what-we-do">
		applications | sites | landings | dashboards | services
	</div>
</section>

<style>
	.hero {
		width: 100%;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}

	.title {
		margin-bottom: 20px;
		font-size: 40px;
		font-weight: 700;
		letter-spacing: 7px;
		transition: all 3s;
	}

	.what-we-are {
		margin-bottom: 10px;
		align-items: center;
		font-size: 28px;
		letter-spacing: 3px;
	}

	.produce {
		font-size: 16px;
		letter-spacing: 3px;
		margin-bottom: 10px;
	}

	.what-we-do {
		align-items: center;
		font-size: 12px;
		letter-spacing: 3px;
		font-weight: 300;
	}

	@media (max-width: 640px) and (orientation: portrait) {
		.title {
			font-size: 24px;
		}

		.what-we-are {
			font-size: 16px;
		}

		.what-we-do {
			font-size: 10px;
			letter-spacing: 1px;
		}
	}

	@media (max-width: 320px) and (orientation: portrait) {
		.what-we-are {
			font-size: 12px;
		}
	}
</style>
